/**
 * Return false because e2e env is not for web at the moment
 */
export const isE2EEnvironment = (): boolean => false
